import type { ISubMenu } from '@/components/sidebar/types';
import { ObjectKeys } from '@/lib/utils';
import type { Menu, Route } from './types';

export const getMenuItems = <T>(menu: Menu<T>) => {
  const routes: Route[] = [];

  for (const key of ObjectKeys(menu)) {
    const current = menu[key];
    routes.push(...getSubMenuItems(current.subMenus));
  }
  return routes;
};

export function getSubMenuItems(subMenus: ISubMenu[]): Route[] {
  const routes: Route[] = [];
  for (const sm of subMenus) {
    const route = routeFromSubMenu(sm);
    if (route) {
      routes.push(route);
    }
    if (sm.subMenus) {
      routes.push(...getSubMenuItems(sm.subMenus));
    }
  }
  return routes;
}

function routeFromSubMenu(sm: ISubMenu): Route | undefined {
  if (!sm.path) {
    return undefined;
  }
  return {
    title: sm.title,
    path: sm.path,
    modelName: sm.modelName,
    modelNames: sm.modelNames,
    pigelloUserOnly: sm.pigelloUserOnly,
    detailModalModelName: sm.detailModalModelName,
    systemManagerOnly: sm.systemManagerOnly,
    pigelloAdminOnly: sm.pigelloAdminOnly,
  };
}
